import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Calendar from "./Calendar";

export default function StudentSlotBooking() {
  return (
    <>
      <MasterLayout>
        <Calendar />{" "}
      </MasterLayout>
    </>
  );
}
